import React from 'react'
import { NavLink } from 'react-router-dom'

 import { makeStyles } from 'tss-react/mui'; // if you still want to use makeStyles


//import mainStyle from "../../assets/mainStyle";
const useStyles = makeStyles()((theme) => ({
    //
      colouredButton: {
        backgroundColor:"#19A78E",
        fontSize: "16px;",
        color: "#fff;",
        fontWeight: "700;",
        textDecoration: "none",
        padding: "13px;",
        borderRadius: "50px;",
        "&:hover":{
            backgroundColor:"#374657",
        }
      },

      clearButton: {
        fontSize: "16px;",
        color: "#374657;",
        fontWeight: "700;",
        textDecoration: "none"
      },
      Center:{
        textAlign: "center;"
      },
    root:{
        marginRight: "10px;",
        //marginBottom: "-10px;",
        maxWidth: "200px;",
        width: "100%;"
  }
  }));

const SiteLogo = (props) => {
    const { classes } = useStyles();
    const {white} = props

/*
    if(white == true)
    {
        return (
            <NavLink to="/">
                <img src="/images/logo-white.svg" className={classes.root}/>
            </NavLink>
        );
    }*/

    return (
        <NavLink to="/">
            <img src="/images/logo.png" className={classes.root}/>
        </NavLink>
    );
}

export default SiteLogo